import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../../_shared/formfield/formfield.component';
import SubmissionHandler from '../../_shared/submissionhandler/submissionhandler';
import Header from '../../_shared/header/header';
import Footer from '../../_shared/footer/footer';
import flatten from '../../_shared/util/flatten';
import { ReadOnlyContentComponent } from '../../_shared/readonlycontent/readonlycontent.component';
import { Helmet } from 'react-helmet';

@inject('appStore', 'routerStore', 'store', 'form')
@observer
export class HomeDetailsComponent extends Component {
    onPrevious() {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/', state: { transition: 'back' } });
    }

    onStartOver(e) {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/', state: { transition: 'back' } });
    }

    render() {
        const { form, store, appStore } = this.props,
            errors = form.errors(),
            prevActionName = 'prev-homedetails-to-start',
            nextActionName = 'next-homedetails-to-floorareadetails';

        return <section className='ht-page ht-homedetails'>
            <Helmet>
                <title>About your Home &raquo; {appStore.baseTitle}</title>
            </Helmet>
            <Header
                titlePre='Tell us about your'
                title='Home'
                idPrefix='homedetails'
                prevActionName={prevActionName}
                prev={{
                    onClick: () => this.onPrevious()
                }}
            />
            <SubmissionHandler store={store}>
                {appStore.councils && (
                    <form className='ht-form'>
                        {store.isReadOnly && (
                            <ReadOnlyContentComponent
                                onClick={e => this.onStartOver(e)}
                            />
                        )}
                        {form.map(field => {
                            field.errors = errors[field.path];
                            return (
                                <FormField
                                    key={field.id}
                                    field={field}
                                    formValues={flatten(form.values())}
                                />
                            );
                        })}
                        <Footer
                            idPrefix='homedetails'
                            nextActionName={nextActionName}
                            prevActionName={prevActionName}
                            next={{
                                text: 'Go to main living room',
                                loading: store.loading,
                                disabled: !form.isValid || (store.error && store.error.code),
                                onClick: e => form.onSubmit(e)
                            }}
                            prev={{
                                text: 'Restart',
                                onClick: () => this.onPrevious()
                            }}
                            showError={!form.isValid}
                            errorMessage={form.error}
                            emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
                        />
                    </form>
                )}
            </SubmissionHandler>
        </section>;
    }
}
